import type { FilterConditionDTO } from "@/shared/contracts/base";
import {
  findCondition,
} from "@/shared/contracts/query-helpers";
import type {
  EventCalendarLayerDTO,
  EventCalendarQueryDTO,
} from "../../domain/contracts/event-calendar";

export const EVENT_CALENDAR_STATUS_LABELS: Record<string, string> = {
  draft: "ກຳລັງວາງແຜນ",
  confirmed: "ຍືນຍັນແລ້ວ",
  completed: "ສຳເລັດ",
  cancelled: "ຍົກເລີກ",
};

export const EVENT_CALENDAR_STATUS_BADGE: Record<string, string> = {
  draft: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  confirmed:
    "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  completed: "bg-muted text-muted-foreground",
  cancelled: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
};

export function parseEventCalendarFilters(filters: FilterConditionDTO[] = []) {
  const title = findCondition(filters, "title")?.value;
  const status = findCondition(filters, "status")?.value;
  const categoryId = findCondition(filters, "categoryId")?.value;

  return {
    title: typeof title === "string" && title.trim() ? title.trim() : undefined,
    status: typeof status === "string" && status.trim() ? status.trim() : undefined,
    categoryId:
      typeof categoryId === "string" && categoryId.trim()
        ? categoryId.trim()
        : undefined,
  };
}

export function buildEventCalendarQuery(input: {
  start: string;
  end: string;
  layer: EventCalendarLayerDTO;
  filters?: FilterConditionDTO[];
}): EventCalendarQueryDTO {
  const parsed = parseEventCalendarFilters(input.filters);
  return {
    start: input.start,
    end: input.end,
    layer: input.layer,
    ...(parsed.status ? { status: parsed.status } : {}),
    ...(parsed.categoryId ? { categoryId: parsed.categoryId } : {}),
    ...(parsed.title ? { title: parsed.title } : {}),
  };
}

export function formatCalendarMonthLabel(monthDate: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${monthDate.getFullYear()}-${pad(monthDate.getMonth() + 1)}`;
}

export function parseCalendarMonth(value: string | undefined): Date {
  if (value && /^\d{4}-\d{2}$/.test(value)) {
    const [y, mo] = value.split("-").map(Number);
    if (y && mo) return new Date(y, mo - 1, 1);
  }
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
}

export function monthRange(monthDate: Date): { start: string; end: string } {
  const start = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  const end = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
  const pad = (n: number) => String(n).padStart(2, "0");
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return { start: fmt(start), end: fmt(end) };
}

export function toYmd(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
